export default __webpack_public_path__ + "055fbde21ad251605af8507970f97e69.png";